var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex" }, [
    _c(
      "div",
      { staticClass: "left-menu" },
      [
        _c("div", { staticClass: "title" }, [_vm._v("帮助中心")]),
        _c(
          "el-menu",
          {
            attrs: {
              "default-active": _vm.activeId,
              "active-text-color": "#ec1c1c"
            },
            on: { open: _vm.handleOpen }
          },
          _vm._l(_vm.docMenus, function(meun) {
            return _c(
              "el-menu-item",
              {
                key: meun.id,
                attrs: { index: meun.id },
                on: {
                  click: function($event) {
                    _vm.activeId = meun.id
                  }
                }
              },
              [
                _c("i", {
                  staticStyle: {
                    color: "#a4bbe7",
                    width: "18px",
                    height: "18px"
                  }
                }),
                _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                  _vm._v(_vm._s(meun.name))
                ])
              ]
            )
          }),
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "view" }, [
      _c(
        "ul",
        { staticClass: "content_box" },
        [_c(_vm.currentComponent, { tag: "component" })],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5f9679a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5f9679a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/product_notice.vue
// module id = Sb/V
// module chunks = 54